import { render, staticRenderFns } from "./DropdownGroup.vue?vue&type=template&id=6c5c529c&scoped=true"
import script from "./DropdownGroup.vue?vue&type=script&lang=js"
export * from "./DropdownGroup.vue?vue&type=script&lang=js"
import style0 from "./DropdownGroup.scss?vue&type=style&index=0&id=6c5c529c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c529c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
